import Vis from './vis/vis'
import Tree from './tree/tree'
import Timeline from './timeline/timeline'
import Debug from './debug/debug'

export var nflowVis = {
  Vis,
  Tree,
  Timeline,
  Debug
}


// WEBPACK FOOTER //
// ./src/index.js